import { useEffect } from 'react';
import { useGLTF, useAnimations } from '@react-three/drei';

const ModelAnimationLogger = () => {
  const { scene, animations } = useGLTF('/models/Character_Male_1.gltf');
  const { actions, names } = useAnimations(animations, scene);
  
  useEffect(() => {
    console.log('=== Character_Male_1.gltf Animations ===');
    console.log('Total animations:', animations.length);
    console.log('Animation names:', names);
    
    animations.forEach((clip, index) => {
      console.log(`Animation ${index}: ${clip.name} (${clip.duration.toFixed(2)}s)`);
    });
    
    console.log('=== Available actions ===');
    console.log(Object.keys(actions));
  }, [animations, names, actions]);
  
  return null;
};

export default ModelAnimationLogger;